var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialsCurl1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 401,
    viewBox: "0 0 527 401",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1224_1032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 527,
    height: 401
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 526.5,
    y: 0.5,
    width: 400,
    height: 526,
    transform: "rotate(90 526.5 0.5)",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1224_1032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.987 -87.1601C410.681 35.7478 281.088 -28.4397 216.489 35.83C140.624 111.309 178.969 200.468 231.986 194.057C285.002 187.646 310.299 114.918 260.583 86.0274C191.534 45.9016 66.2555 97.1541 38.1166 275.58C23.9733 365.262 -51.4226 377.775 -79.4897 371.005",
    stroke: "white",
    strokeWidth: 40
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialsCurl1);
export default __webpack_public_path__ + "static/media/socials_curl1.62382e47bd3222d9e1de980a4103356b.svg";
export { ForwardRef as ReactComponent };